// @hooks
import useSWR from "swr";

// @utils
import { fetcher } from "@/utils";
import { useVariation } from "@/app/liquidity/store";

const endpoint = "/api/liquidity";

function liquidityUrl(path: string, variation: string) {
  return `${endpoint}/${path}?variant=${encodeURIComponent(variation)}`;
}

export function useHomeLiquidityPreview(shouldFetch: boolean = true) {
  const variant = encodeURIComponent("EHEX & PHEX");
  return useSWR(
    shouldFetch ? `${endpoint}/token-pairs?variant=${variant}` : null,
    fetcher,
    { refreshInterval: 60_000 },
  );
}

export function useTokenPairs(shouldFetch: boolean = true) {
  const variation = useVariation((s: { variation: string }) => s.variation);
  return useSWR(
    shouldFetch ? liquidityUrl("token-pairs", variation) : null,
    fetcher,
    { refreshInterval: 60_000 },
  );
}

export function useDex(shouldFetch: boolean = true) {
  const variation = useVariation((s: { variation: string }) => s.variation);
  return useSWR(
    shouldFetch ? liquidityUrl("dex", variation) : null,
    fetcher,
    { refreshInterval: 60_000 },
  );
}

export function useBidAsk(shouldFetch: boolean = true) {
  const variation = useVariation((s: { variation: string }) => s.variation);
  return useSWR(
    shouldFetch ? liquidityUrl("bid-ask", variation) : null,
    fetcher,
    { refreshInterval: 60_000 },
  );
}

export function useTableData(shouldFetch: boolean = true) {
  const variation = useVariation((s: { variation: string }) => s.variation);
  return useSWR(
    shouldFetch ? liquidityUrl("table-data", variation) : null,
    fetcher,
    { refreshInterval: 60_000 },
  );
}

export function useRawData(shouldFetch: boolean = true) {
  const variation = useVariation((s: { variation: string }) => s.variation);
  return useSWR(
    shouldFetch ? liquidityUrl("raw-lp", variation) : null,
    fetcher,
    { refreshInterval: 60_000 },
  );
}
